import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TranslationNS } from '@gokrew/models/constants';
import { KollabHRFullLogo, BrandPanelIllustration } from '@gokrew/ui/assets';
import { BrandUnderline } from '@gokrew/ui/components';
import styles from './BrandPanel.module.css';

/**
 * Branded left panel for the auth split layout. Mirrors the Frontend Auth V2
 * brand panel exactly — light-blue backdrop, yellow circle sweep, fade-up
 * body, animated headline underline and the flush-bottom illustration — with
 * copy tailored to the Employee Portal and no cross-portal CTA.
 */
export const BrandPanel = () => {
  const { t } = useTranslation(TranslationNS.Auth);
  // The signing gate is also opened by job candidates, who have no employee
  // account: it gets neutral copy, not the employee portal pitch (P2-28).
  const { pathname } = useLocation();
  const copy = pathname.startsWith('/sign') ? 'brand_sign' : 'brand';

  return (
    <div className={styles.panel}>
      {/* Yellow circle sweep — animates from bottom-center outward */}
      <div className={styles.bgSweep} aria-hidden="true" />

      {/* Logo */}
      <Link to="/login" className={styles.logoLink}>
        <img src={KollabHRFullLogo} alt="KollabHR" className={styles.logo} />
      </Link>

      {/* Main body — headline + tagline */}
      <div className={styles.body}>
        <h1 className={styles.headline}>
          <span>{t(`${copy}.headline_line1`)}</span>
          <br />
          <span>{t(`${copy}.headline_line2`)}</span>
          <br />
          {/* Last line gets the animated curved underline */}
          <span className={styles.headlineUnderlined}>
            {t(`${copy}.headline_line3`)}
            <BrandUnderline />
          </span>
        </h1>

        <p className={styles.tagline}>{t(`${copy}.tagline`)}</p>
      </div>

      {/* Illustration — sits flush at the bottom */}
      <div className={styles.illustrationWrap} aria-hidden="true">
        <img
          src={BrandPanelIllustration}
          alt=""
          className={styles.illustration}
        />
      </div>
    </div>
  );
};
